import { OperatorsTableList } from "../../../Operators";
import { Button } from "@mui/material";
import { PersonAdd } from "@mui/icons-material";
import Tooltip from "../../../../../Components/Atoms/Tooltip";
import CreateOperatorModal from "../../../Operators/CreateOperatorModal";
import React from "react";

type Props = {
  operators: any[];
  subAccountId?: string;
  onChanged?: () => void;
};

const OperadoresSection = ({ operators, subAccountId, onChanged }: Props) => {
  const [open, setOpen] = React.useState(false);
  const [editingId, setEditingId] = React.useState<string | null>(null);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div />
        <Tooltip title="Adicionar operador">
          <Button
            variant="contained"
            sx={{ color: 'white' }}
            startIcon={<PersonAdd fontSize="small" />}
            onClick={() => { setEditingId(null); setOpen(true); }}
          >
            Adicionar
          </Button>
        </Tooltip>
      </div>

      <OperatorsTableList
        operators={operators}
        isHiddenSubAccountLink
        onEdit={(id: string) => { setEditingId(id); setOpen(true); }}
      />

      <CreateOperatorModal
        open={open}
        operatorId={editingId || undefined}
        onClose={() => { setOpen(false); setEditingId(null); }}
        onSaved={() => { onChanged?.(); setOpen(false); setEditingId(null); }}
        defaultProfile={'subAccount'}
        defaultSubAccountId={subAccountId}
      />
    </>
  );
}

export default OperadoresSection;
